<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>
  <!--begin::Tables Widget 11-->
  <div :class="widgetClasses" class="card" v-show="!loading">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Available Activators</span>
      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3">
      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">Ref. #</th>
              <th class="min-w-225px">Date</th> 
              <th class="min-w-125px">Action</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>&nbsp;&nbsp;&nbsp;{{item.recid}}</td>
                <td>{{item.dtestp}}</td>
                <td>
                  <el-button type="primary" size="small" @click="activateAi(item.recid, item)">
                    Activate AI
                  </el-button>
                </td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
        

      </div> 
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
        <!-- Modal --> 
  </div>
  <!--end::Tables Widget 11--> 
    <button type="button" ref="activateAiButton"  v-show="false"  class="btn btn-primary er fs-6 px-8 py-4"  data-bs-toggle="modal" :data-bs-target="`#kt_modal_activate_ai`"  >
      Click here
    </button> 
    <ActivateAi  :key="selectedRecid" :activation="activation" @close="showModal = false" />

     
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { activators } from "@/api/ai"; 
import ActivateAi from "./ActivateAi.vue";

export default defineComponent({
  name: "ai-activators", 
  components: {   
    ActivateAi
  },
  data() {
    return { 
      list: [],
      loading: true, 
      selectedRecid: 0,
      activation: {},
      showModal: false
    };
  },
  methods: {
    async activatorsList() { 
      this.loading = true;
      const response = await activators(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
    activateAi(recid: number, item: any) {
      //console.log("Activating AI for recid:", recid);
      this.selectedRecid = recid;
      this.activation = item;

      //add delay to allow data binding to complete. make sure modal shows correct data
      setTimeout(() => {
        const btn2:any = this.$refs.activateAiButton;
        btn2.click();
        this.showModal = true;
       }, 200); // 200ms delay
    }
  },
  mounted() {
    this.activatorsList();
  }, 
  props: {
    widgetClasses: String
  }
});
</script>
